<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-period-module :dto="config.timing" :options="options" :mode-select="true"
                              :compare="true"></timing-period-module>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row row-cols-4">
                        <div class="col">
                            <div class="form-group">
                                <label><b>PZN</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-name"
                                           v-model="config.pznName">
                                    <label class="form-check-label" for="pzn-name">
                                        Artikelname
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-menge-einheit"
                                           v-model="config.pznMengeEinheit">
                                    <label class="form-check-label" for="pzn-menge-einheit">
                                        Menge und Einheit
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-dar"
                                           v-model="config.pznDar">
                                    <label class="form-check-label" for="pzn-dar">
                                        Darreichungsform
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-anbieter"
                                           v-model="config.pznAnbieter">
                                    <label class="form-check-label" for="pzn-anbieter">
                                        Anbieter
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-In</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="einkauf-absatz"
                                           v-model="config.einkaufAbsatz">
                                    <label class="form-check-label" for="einkauf-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="einkauf-umsatz"
                                           v-model="config.einkaufUmsatz">
                                    <label class="form-check-label" for="einkauf-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-Out</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="verkauf-absatz"
                                           v-model="config.verkaufAbsatz">
                                    <label class="form-check-label" for="verkauf-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="verkauf-umsatz"
                                           v-model="config.verkaufUmsatz">
                                    <label class="form-check-label" for="verkauf-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Rohertrag</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="profit-normal"
                                           v-model="config.profit">
                                    <label class="form-check-label" for="profit-normal">
                                        Normaler Rohertrag
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="profit-kalkuliert"
                                           v-model="config.profitKalkuliert">
                                    <label class="form-check-label" for="profit-kalkuliert">
                                        Kalkulierter Rohertrag
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="profit-filter"
                                           v-model="config.profitFilter">
                                    <label class="form-check-label" for="profit-filter">
                                        Gefilterter Rohertrag
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="profit-listen-ek"
                                           v-model="config.profitListenEk">
                                    <label class="form-check-label" for="profit-listen-ek">
                                        Rohertrag auf Listen EK
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Marktanalyse</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="marktanalyse-absatz"
                                           v-model="config.marktanalyseAbsatz">
                                    <label class="form-check-label" for="marktanalyse-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="marktanalyse-umsatz"
                                           v-model="config.marktanalyseUmsatz">
                                    <label class="form-check-label" for="marktanalyse-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Sell-In</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellIn.mode']"></i>
                            <b>Modus</b>
                        </label>
                        <select class="form-control" v-model="config.sellInMode">
                            <option value="all-split">Anbieter und Großhandel - Getrennt</option>
                            <option value="all-sum">Anbieter und Großhandel - Summe</option>
                            <option value="anbieter">Anbieter</option>
                            <option value="grosshandel">Großhandel</option>
                        </select>
                        <div class="form-check mt-2" v-if="config.sellInMode !== 'all-sum'">
                            <input class="form-check-input" type="checkbox" value="" id="sell-in-mode-switch"
                                   v-model="config.sellInModeSwitch">
                            <label class="form-check-label" for="sell-in-mode-switch">
                                <i class="fas fa-info-circle text-muted"
                                   style=""
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   :title="$info['sellIn.modeSwitch']"></i>
                                Überweiser in Direktgeschäft
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <fieldset class="border px-3 mb-3">
                                <legend class="w-auto">{{ sellInHeaders[0] }}</legend>

                                <div class="form-group">
                                    <label><b>Umsatz Basis</b></label>
                                    <select class="form-control" v-model="config.sellIn1Base">
                                        <option value="listenek">Listen EK</option>
                                        <option value="nettoek">Netto EK</option>
                                        <option value="listenvk">Listen VK</option>
                                        <option value="kalkuliertervk">Kalkulierter VK</option>
                                    </select>
                                </div>

                                <div class="form-check my-2"
                                     v-if="['listenvk', 'kalkuliertervk'].includes(config.sellIn1Base)">
                                    <input class="form-check-input" type="checkbox" value="" id="sell-in-1-tax"
                                           v-model="config.sellIn1RemoveTax">
                                    <label class="form-check-label" for="sell-in-1-tax">
                                        <i class="fas fa-info-circle text-muted"
                                           style=""
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           :title="$info['sellOut.removeTax']"></i>
                                        Mwst. herausrechnen
                                    </label>
                                </div>

                                <div class="form-check my-2"
                                     v-if="['all-split', 'anbieter'].includes(config.sellInMode)">
                                    <input class="form-check-input" type="checkbox" value="" id="sell-in-1-discount"
                                           v-model="config.sellIn1Discount">
                                    <label class="form-check-label" for="sell-in-1-discount">
                                        <i class="fas fa-info-circle text-muted"
                                           style=""
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           :title="$info['sellIn.discount']"></i>
                                        Direktrabatt anzeigen
                                    </label>
                                </div>
                            </fieldset>
                        </div>
                        <div class="col" v-if="sellInHeaders.length > 1">
                            <fieldset class="border px-3 mb-3">
                                <legend class="w-auto">{{ sellInHeaders[1] }}</legend>

                                <div class="form-group">
                                    <label><b>Umsatz Basis</b></label>
                                    <select class="form-control" v-model="config.sellIn2Base">
                                        <option value="listenek">Listen EK</option>
                                        <option value="nettoek">Netto EK</option>
                                        <option value="listenvk">Listen VK</option>
                                        <option value="kalkuliertervk">Kalkulierter VK</option>
                                    </select>
                                </div>

                                <div class="form-check my-2"
                                     v-if="['listenvk', 'kalkuliertervk'].includes(config.sellIn2Base)">
                                    <input class="form-check-input" type="checkbox" value="" id="sell-in-2-tax"
                                           v-model="config.sellIn2RemoveTax">
                                    <label class="form-check-label" for="sell-in-2-tax">
                                        <i class="fas fa-info-circle text-muted"
                                           style=""
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           :title="$info['sellOut.removeTax']"></i>
                                        Mwst. herausrechnen
                                    </label>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Sell-Out</legend>

                    <div class="form-group">
                        <label><b>Umsatz Basis</b></label>
                        <select class="form-control" v-model="config.sellOutBase">
                            <option value="listenek">Listen EK</option>
                            <option value="nettoek">Netto EK</option>
                            <option value="listenvk">Listen VK</option>
                            <option value="listenvkfallback">Listen VK (Fallback)</option>
                            <option value="tatsaechlichervk">Netto VK</option>
                        </select>
                    </div>

                    <div class="form-check my-2"
                         v-if="['listenvk', 'listenvkfallback', 'tatsaechlichervk'].includes(config.sellOutBase)">
                        <input class="form-check-input" type="checkbox" value="" id="sell-out-tax"
                               v-model="config.sellOutRemoveTax">
                        <label class="form-check-label" for="sell-out-tax">
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellOut.removeTax']"></i>
                            Mwst. herausrechnen
                        </label>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Weitere Seiten</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['pages.anbieter']"></i>
                            <b>Anbieter</b>
                        </label>
                        <select class="form-control" v-model="config.pageAnbieter">
                            <option value="disabled">Deaktiviert</option>
                            <option value="simple">Nur Anbieter</option>
                            <option value="extended">Anbieter inklusive PZN</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['pages.coops']"></i>
                            <b>Kooperationen</b>
                        </label>
                        <select class="form-control" v-model="config.pageCoops">
                            <option value="disabled">Deaktiviert</option>
                            <option value="split">Getrennte Kooperationen</option>
                        </select>
                    </div>
                </fieldset>

                <fieldset class="border px-3" v-if="!(options.disabledFeatures || []).includes('panel_settings')">
                    <legend class="w-auto">Prozentregelung</legend>

                    <div class="form-group" v-if="config.timing.comparePeriods">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPercent']"></i>
                            <b>Panelgröße</b>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="100" v-model="config.panelPercent">
                        </div>
                    </div>

                    <div class="form-group" v-if="config.timing.comparePeriods">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelBase']"></i>
                            <b>Berechnungsgrundlage</b>
                        </label>
                        <select class="form-control" v-model="config.panelBase">
                            <option value="sell-out">Sell Out</option>
                            <option value="sell-in">Sell In</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPeriod']"></i>
                            <b>Startdatum Modus</b>
                        </label>
                        <select class="form-control" v-model="config.panelPeriod">
                            <option value="full">Gesamtzeitraum</option>
                            <option value="quarterly-start">Quartalsweise - Anfang</option>
                            <option value="quarterly-middle">Quartalsweise - Mitte</option>
                            <option value="quarterly-end">Quartalsweise - Ende</option>
                            <option value="monthly">Monatlich</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['markt.panelFilter']"></i>
                            Filter PZN
                        </label>
                        <custom-select v-model="config.panelPzn"
                                       ref="panelPzn"
                                       :settings="pznSettings"/>
                        <div class="mt-1">
                            <button type="button" class="btn btn-sm btn-outline-primary mr-1"
                                    v-for="group in panelPznSuggestions"
                                    @click="addPanelPznGroup(group)">
                                Hinzufügen: {{ group }}
                            </button>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['markt.panelFilter']"></i>
                            Filter Anbieter
                        </label>
                        <custom-select v-model="config.panelAnbieter"
                                       :settings="anbieterSettings"/>
                        <div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" :name="'panel' + 'anbieterMode'"
                                       :id="'panel' + 'anbieterModeInklusiv'"
                                       value="inclusive"
                                       v-model="config.panelAnbieterMode">
                                <label class="form-check-label" :for="'panel' + 'anbieterModeInklusiv'">
                                    Inklusiv
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" :name="'panel' + 'anbieterMode'"
                                       :id="'panel' + 'anbieterModeExklusiv'"
                                       value="exclusive"
                                       v-model="config.panelAnbieterMode">
                                <label class="form-check-label" :for="'panel' + 'anbieterModeExklusiv'">
                                    Exklusiv
                                </label>
                            </div>
                        </div>
                    </div>
                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering"
                          :options="options"
                          :pzn-groups="true"
                          :wholesalers="true"
                          :warengruppen="true"
                          :anbieter-mode="true"
                          :dar="true"
                          :menge="true"
                          :wirkstoffe="true"
                          :reimport="true"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../Modules/TimingPeriodModule";
import FilteringModule from "../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
            pznSettings: {
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
            anbieterSettings: {
                ajax: {
                    url: '/select/anbieter',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
        };
    },
    computed: {
        sellInHeaders() {
            const headers = [];
            if (this.config.sellInMode === 'all-sum') {
                headers.push('Summe');
            }
            if (this.config.sellInMode === 'all-split') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Direkt & Überweiser');
                    headers.push('Großhandel');
                } else {
                    headers.push('Direkt');
                    headers.push('Großhandel');
                }
            }
            if (this.config.sellInMode === 'anbieter') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Direkt & Überweiser');
                } else {
                    headers.push('Direkt');
                }
            }
            if (this.config.sellInMode === 'grosshandel') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Großhandel ohne Überweiser');
                } else {
                    headers.push('Großhandel');
                }
            }

            return headers;
        },
        panelPznSuggestions() {
            if (Array.isArray(this.config.filtering.pznGroups)) {
                return [];
            }

            return Object.keys(this.config.filtering.pznGroups).filter((group) => {
                return !this.config.panelPzn.includes('group:' + group);
            });
        }
    }
}
</script>
